import { Get, HvHostMap, Post, Put } from '../helpers';
import { StaticVideo, DownloadRecordedRequest, VideoCaption, CreateVideo, ArchivedVideo } from '@/types/video.types';

export const GetUploadedVideos = (channel: number): Promise<StaticVideo[]> => {
  return Get({ url: `/v4/videos/channel/${channel}/uploaded` });
};

export function GetRecordedVideos(channel: number): Promise<StaticVideo[]> {
  return Get({ url: `/v4/videos/channel/${channel}/recorded` });
}

export function GetPendingDownloadRequests(channel: number): Promise<DownloadRecordedRequest[]> {
  return Get({ url: `/v4/videos/channel/${channel}/recorded/downloads/pending` });
}

export function GetRecordedVideoDownload(channel: number, videoUuid: string): Promise<DownloadRecordedRequest> {
  return Get({ url: `/v4/videos/channel/${channel}/recorded/${videoUuid}/download` });
}

export function GetRecordingJWT(path?: string): Promise<{ jwtToken: string }> {
  let endpoint = '/e3-get-recording-jwt';

  if (path) {
    endpoint += `?path=${path}`;
  }

  return Get({ url: `${HvHostMap.eventData}/${endpoint}` });
}

export function UpdateVideoCaptionFileSource(channel: number, videoCaption: VideoCaption): Promise<void> {
  return Put({
    url: `/v4/videos/channel/${channel}/videos/${videoCaption.static_video_uuid}/caption`,
    body: videoCaption,
  });
}

type AddStaticVideoCaptionFileInput = {
  channel: number;
  videoCaption: Partial<VideoCaption>;
};

export function AddStaticVideoCaptionFile({ channel, videoCaption }: AddStaticVideoCaptionFileInput): Promise<void> {
  return Post({
    url: `/v4/videos/channel/${channel}/videos/${videoCaption.static_video_uuid}/caption`,
    body: videoCaption,
  });
}

export function GetVideoCaptions(channel: number, videoUuid: string): Promise<VideoCaption[]> {
  return Get({ url: `/v4/videos/channel/${channel}/videos/${videoUuid}/captions` });
}

export function UploadVideo(channel: number, video: CreateVideo | StaticVideo): Promise<StaticVideo> {
  return Post({
    path: `/v4/videos/channel/${channel}/video`,
    body: video,
  });
}

export function DeleteVideos(
  channel: number,
  videoUuids: string[]
): Promise<{ videoIDs: string[]; cannotDelete: string[] }> {
  return Post({ url: `/v4/videos/channel/${channel}/videos/delete`, body: { videoUuids } });
}

export function GetArchivedVideos(
  channel: number,
  search: string,
  offset: number,
  limit: number,
  sortBy: string
): Promise<{ videos: ArchivedVideo[]; count: number }> {
  return Get({
    url: `/v3/admin/video-archive/${channel}?search=${search}&limit=${limit}&offset=${offset}&sortBy=${sortBy}`,
  });
}
